// @flow
import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';
import cookiesPolicy                 from 'fg-frontend/components/CookiesPolicy/index';
import phoneLink                     from 'fg-frontend/components/PhoneLink';

import configureWebComponents from './configureWebComponents';
import configureWebActions    from './configureWebActions';

import 'fg-frontend/ramjet/liveValidation';
import 'bootstrap/js/dist/collapse';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, [ 'keyup' ]);
autoTitleLinksWithBlankTarget();
phoneLink();
// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();

cookiesPolicy();





// WEBPACK FOOTER //
// ./fe/web-career/src/js/configureWeb.js